const getMetaContent = (name) => {
  const metas = Array.prototype.slice.call(global.document.getElementsByTagName('meta'), 0);
  const result = metas.find((meta) => meta.name === name);

  return result ? result.content : '';
};

export {
  getMetaContent
};
